import { Component, OnInit } from '@angular/core';
import { RetrievefeesitemService } from './retrievefeesitem.service';

interface FeeScope {
  studentType: string;
  academicYear: string;
  semester: string;
}

@Component({
  selector: 'app-retreivefeeitems',
  templateUrl: './retreivefeeitems.component.html',
  styleUrls: ['./retreivefeeitems.component.scss']
})
export class RetreivefeeitemsComponent implements OnInit {

  academicYears = ['2027/2028','2026/2027', '2025/2026', '2024/2025', '2023/2024'];
  semesters     = ['SEM1', 'SEM2'];
  studentTypes  = ['GHANAIAN', 'INTERNATIONAL'];

  latestScope: FeeScope = {
    studentType: 'GHANAIAN',
    academicYear: '2025/2026',
    semester: 'SEM1'
  };

  scope: FeeScope = { ...this.latestScope };

  feeItems: any[] = [];
  loading = false;
  errorMessage = '';

  constructor(private feeService: RetrievefeesitemService) {}

  ngOnInit(): void {
    this.fetchFeeItems();
  }

  get isCurrentScope(): boolean {
    return this.scope.studentType === this.latestScope.studentType &&
           this.scope.academicYear === this.latestScope.academicYear &&
           this.scope.semester === this.latestScope.semester;
  }

  onScopeChange(): void {
    this.fetchFeeItems();
  }

  resetToLatest(): void {
    this.scope = { ...this.latestScope };
    this.fetchFeeItems();
  }

  private fetchFeeItems(): void {
    this.loading = true;
    this.errorMessage = '';

    this.feeService.getByScope(
      this.scope.studentType,
      this.scope.academicYear,
      this.scope.semester
    ).subscribe({
      next: (res) => {
        this.feeItems = res || [];
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'Failed to load fee items';
        this.loading = false;
      }
    });
  }

  get totalAmount(): number {
    return this.feeItems.reduce((sum, i) => sum + (Number(i.amount) || 0), 0);
  }
}